import { TownsquareSiteAri, TownsquareTagAri } from '@atlassian/ari';
import { getSiteId } from '@atlassian/projects-goals-common/get-site-id';

import { createRelayResource, type RelayResourceConfig } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceContext } from '@townsquare/router/types';

import TagUpdatesFeedAggQuery, {
	type TagUpdatesFeedAggQuery as TagUpdatesFeedAggQueryType,
} from '../TagUpdatesView/agg/__generated__/TagUpdatesFeedAggQuery.graphql';

export const tagUpdatesAggResource = createRelayResource<TagUpdatesFeedAggQueryType>({
	getQuery: (routerContext, resourceContext): RelayResourceConfig<TagUpdatesFeedAggQueryType> => {
		const { collabContext } = resourceContext as ResourceContext;
		const siteId = getSiteId('site', collabContext?.contextId ?? '');
		const tagUuid = routerContext?.match?.params.id ?? '';

		return {
			query: TagUpdatesFeedAggQuery,
			variables: {
				tagId: TownsquareTagAri.create({
					tagUuid,
					siteId,
				}).toString(),
				containerId: TownsquareSiteAri.create({ siteId }).toString(),
				shouldFetchUpdatesTabData: true,
			},
			environment: getAggRelayEnvironment(),
			options: {
				fetchPolicy: 'store-and-network',
			},
		};
	},
});
